<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.deviceName')" prop="title">
                            {{ rowInfo.title }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.deviceCode')" prop="score">
                            {{ rowInfo.code }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.model')" prop="staff">
                            {{ rowInfo.model }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.partName')" prop="start_time">
                            {{ rowInfo.name }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.planContent')" prop="end_time">
                            {{ rowInfo.content }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.scheduleDate')" prop="end_time">
                            {{ rowInfo.schedule_date ? rowInfo.schedule_date.split(' ')[0] : '-' }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.assignee')" prop="end_time">
                            {{ rowInfo.real_name }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item :label="t('maintenance.materials')">
                            <hc-oss-image-list :value="rowInfo.material_url" />
                            <!-- <el-upload v-model:file-list="fileList" :action="state.uploadUrl" :headers="state.headers"
                                list-type="picture-card" :on-success="onSuccess" :limit="3" :accept="acceptTypes"
                                :before-upload="beforeUpload">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload> -->
                        </el-form-item>
                    </el-col>

                    <el-divider></el-divider>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.submitInfo')" prop="status">
                            {{ rowInfo.remark }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenance.auditStatus')" prop="status">
                            {{ statusMap[rowInfo.status] }}
                        </el-form-item>
                    </el-col>

                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('maintenance.close') }}</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    computed,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { auditApi } from "@/api/maintenance/maintenance.js";
import { t } from "@/composables/usePageI18n.js";

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "详情",
    },
    currentTask: {
        type: Object,
        default: () => { },
    }
});

const rules = reactive({
    // username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    // real_name: [{ required: true, message: "请输入手机", trigger: "blur" }],
});

const statusMap = computed(() => ({
    2: t('maintenance.pass'),
    4: t('maintenance.reject'),
}))

const fileList = computed(() => {
    return JSON.parse(rowInfo?.material_url ?? '[]')
})
const getImgArr = (str) => {
    if (!str || str.length === 0) {
        return []
    }
    return JSON.parse(str).map(i => i.url)
}
const state = reactive({
    dialogVisible: false,
    form: {
        "id": 0,
        "status": 4,
    }
});

const rowInfo = ref(null)
const open = (row) => {
    state.dialogVisible = true;
    rowInfo.value = row
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = JSON.stringify({
                id: rowInfo.value.id,
                status: state.form.status
            })
            auditApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success('操作成功')
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "status": 4
                    }
                    emit('refresh')
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {

});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
.record-img {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
